import { PetRepository } from "../interfaces";
import { PetRecord } from "../types";
import { InMemoryStore, nextId } from "./store";

export class InMemoryPetRepository implements PetRepository {
  constructor(private store: InMemoryStore) {}

  async getForClient(clientID: string): Promise<PetRecord[]> {
    return this.store.pets.filter((p) => p.clientID === clientID);
  }

  async save(pet: PetRecord, isNew: boolean): Promise<PetRecord> {
    if (isNew) {
      const created: PetRecord = { ...pet, id: nextId("pet") };
      this.store.pets.push(created);
      return created;
    }
    const idx = this.store.pets.findIndex((p) => p.id === pet.id);
    if (idx < 0) throw new Error("Failed to find pet to update");
    this.store.pets[idx] = { ...this.store.pets[idx], ...pet };
    return this.store.pets[idx];
  }

  async delete(id: string): Promise<void> {
    this.store.pets = this.store.pets.filter((p) => p.id !== id);
  }
}
